export default __webpack_public_path__ + "static/media/lenovo.1c6618e1.png";